import React from 'react';
import { Group, Panel, Separator } from 'react-resizable-panels';
import './TechnicianColumnStack.css';

/**
 * Shell resizable para 2 ou 3 colunas de técnico empilhadas.
 *
 * @param {{ hostKey: string, panels?: React.ReactNode[], top?: React.ReactNode, bottom?: React.ReactNode }} props
 */
export function TechnicianStackedColumnResizable({ hostKey, panels, top, bottom }) {
  const groupId = `tech-stack-${String(hostKey || 'host').replace(/\s+/g, '-')}`;
  const items = Array.isArray(panels) && panels.length ? panels : [top, bottom].filter(Boolean);
  const count = Math.max(items.length, 1);
  const defaultSize = `${Math.round(100 / count)}%`;
  const minSize = count >= 3 ? '14%' : '22%';

  return (
    <Group
      id={groupId}
      orientation="vertical"
      className="technician-column-stack-shell technician-column-stack-shell--resizable"
      style={{ width: 320, minWidth: 320, maxWidth: 320, flex: '0 0 320px' }}
    >
      {items.map((node, index) => (
        <React.Fragment key={`${groupId}-slot-${index}`}>
          {index > 0 ? (
            <Separator className="technician-column-stack-separator" aria-label="Redimensionar colunas empilhadas">
              <span className="technician-column-stack-handle" aria-hidden />
            </Separator>
          ) : null}
          <Panel
            id={`${groupId}-p${index}`}
            defaultSize={defaultSize}
            minSize={minSize}
            className="technician-column-stack-panel"
          >
            {node}
          </Panel>
        </React.Fragment>
      ))}
    </Group>
  );
}

export default TechnicianStackedColumnResizable;
